import styles from './use-position-table-actions.module.scss';

import { gql, useApolloClient } from '@apollo/client';
import { useCallback, useMemo } from 'react';

import { WebsiteFavicon } from '@work4all/components';
import { CustomToolbarMappedAction } from '@work4all/components/lib/dataDisplay/actions-bar/ToolbarTypes';

import { useDataProvider } from '@work4all/data';

import { WebShopDefinition } from '@work4all/models/lib/Classes/WebShopDefinition.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

const GET_WEB_SHOP_URL = gql`
  query getWebShopUrl($getWebShopUrlId: Guid, $shadowBzObjectId: Guid) {
    getWebShopUrl(id: $getWebShopUrlId, shadowBzObjectId: $shadowBzObjectId)
  }
`;

export const useWebShopActions = (props: {
  shadowBzObjectId: string;
  onRequestStart?: () => void;
}): CustomToolbarMappedAction[] => {
  const { shadowBzObjectId, onRequestStart } = props;
  const client = useApolloClient();

  const req = useMemo<DataRequest>(() => {
    return {
      entity: Entities.webShopDefinition,
      data: {
        id: null,
        customerNumber: null,
        url: null,
        password: null,
        name: null,
        sDObjMembercode: null,
        userName: null,
      } as WebShopDefinition,
      completeDataResponse: true,
    } as DataRequest;
  }, []);

  const { data } = useDataProvider<WebShopDefinition>(req);

  const handleClick = useCallback(
    async (ociId: string) => {
      onRequestStart?.();
      const getWebShopUrlResponse = await client.query({
        fetchPolicy: 'no-cache',
        query: GET_WEB_SHOP_URL,
        variables: {
          getWebShopUrlId: ociId,
          shadowBzObjectId,
        },
      });

      window.open(getWebShopUrlResponse.data.getWebShopUrl, '_blank');
    },
    [client, shadowBzObjectId, onRequestStart]
  );

  return useMemo<CustomToolbarMappedAction[]>(() => {
    return data.map(
      (item) =>
        ({
          actionKey: item.id,
          title: item.name,
          IconComponent: () => (
            <WebsiteFavicon website={item.url} className={styles.icon} />
          ),

          onClick: () => handleClick(item.id),
        } as CustomToolbarMappedAction)
    );
  }, [data, handleClick]);
};
